import { render, staticRenderFns } from "./ProjectsLists.vue?vue&type=template&id=172dfa33&scoped=true&"
import script from "./ProjectsLists.vue?vue&type=script&lang=ts&"
export * from "./ProjectsLists.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectsLists.vue?vue&type=style&index=0&id=172dfa33&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "172dfa33",
  null
  
)

export default component.exports